import { createFileRoute } from '@tanstack/react-router';
import { devicesQuery } from '@/features/devices/api';
import { DeviceInfoPage, type DeviceInfoSearch } from '@/features/devices/pages/DeviceInfoPage';

const str = (v: unknown) => (typeof v === 'string' && v ? v : undefined);

/**
 * "Qurilma haqida ma'lumot" (586:14946). URL state: `?panel=new|<id>` side panel (586:15927), `?view=<id>` detail modal
 * (586:17184), `?passport=<id>` passport viewer (586:17481).
 */
export const Route = createFileRoute('/_authed/t/$tenantSlug/_shell/devices/info')({
  validateSearch: (search: Record<string, unknown>): DeviceInfoSearch => ({
    panel: str(search.panel),
    view: str(search.view),
    passport: str(search.passport),
  }),
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(devicesQuery(context.tenant.id));
  },
  component: DeviceInfoRoute,
});

function DeviceInfoRoute() {
  const { tenant } = Route.useRouteContext();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return <DeviceInfoPage tenant={tenant} search={search} onSearch={(next) => void navigate({ search: next })} />;
}
